<template>
  <!-- 隐私协议、用户条款的 header -->
  <div class="privacy-header">
    <logo class="logo-instance" type="logged"></logo>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .privacy-header{
    width: 980px;
    height: 56px;
    margin: 0 auto;
    position: relative;
    .logo-instance{
      float: left;
      margin-left: -24px;
    }
  }
</style>
<script>
import Logo from '_c/Logo.vue'
export default {
  name: 'HeaderPrivacy',
  components: {
    Logo
  }
}
</script>
